import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { transactionReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"
let rand = require("random-key");

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  transactionReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class TransactionReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'TRANSACTION_REPORT',
      path: ["Home", "Transaction Report"],
      links: ["home", "report/transaction"],
      date: new Date(),
      range: false,
      disabled: false,
      catID: "",
      merchantTypeID: "",
      sales: [],
      isLoading: "false",
      csvData: "",
      offerIDs: "",
      transaction : "",
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      this.setState({ sales: "" });
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          catID: this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          offerIDs: this.state.offerIDs,
          site_id: localStorage.getItem("siteID")
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          catID: this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          offerIDs: this.state.offerIDs,
          site_id: localStorage.getItem("siteID")
        };
      }

      this.props.transactionReport(formData);
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMerchantType({site_id: localStorage.getItem("siteID")});
    this.props.getAllCategorys({site_id: localStorage.getItem("siteID")});
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantType: nextProps.merchantType });
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        this.setState({ catData: nextProps.catData.data.data });
      }
    }

    if (this.props.transaction !== nextProps.transaction) {
      if (nextProps.transaction) {
        isLoading = "false";
        this.setState({ transaction: nextProps.transaction.data });
        this.handleExport(nextProps.transaction.data);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    csvData = [
      [
        "#",
        "Proposal Type",
        "Offer ID",
        "Offer Name",
        "Original Price",
        "Offer Price",
        "Launch Date",
        "End Date",
        "City",
        "State",
        "Country",
        "Customer First Name",
        "Customer Last Name",
        "Customer Email",
        "Customer Phone",
        "Customer Address",
        "Transaction ID",
        "Transaction Date",
        "Transaction Time",
        "Currency",
        "Credit Card Sale",
        "User Credits Used ",
        "Promo Code Credit Used",
        "Gross Sale",
        "Shipping to Site",
        "Shipping to Merchant",
        "Tax Percentage",
        "Tax Amount",
        "Credit Card %",
        "Credit Card Fee",
        "Refunds",
        "Adjusted Gross",
        "Site Commission",
        "Site Commission %",
        "Merchant Remittance",
        "Merchant Remittance %",
        "Net Payout To Merchant",
        "Final Merchant Payout ",
        "Net To Site",
        "Payment Method",
        "Sales Rep Full Name",
        "Payment Status",
        "Pricing Option Deal Title",
        "Offer Option",
        "Merchant ID",
        "Merchant Email",
        "Phone",
        "Vouchers",
        "Gross Billing",
        "Payvibe Commission",
        "Payvibe Commission %",
        "Tracking Info Date/Time",
        "Additional Notes",
        "Categories",
        "Billing Address",
        "Billing City",
        "Billing State",
        "Billing Zip",
        "Shipping Address",
        "Shipping City",
        "Shipping State",
        "Shipping Zip",
        "Charity Name",
      ]
    ];

    {data &&
      data.map((data, keyIndex) =>
        Object.keys(data).map((key, indexkey) =>
          (key == 'title') ?
            csvData.push([data.title])
          :
            (key == 'transactions') &&
            data.transactions.map((tran, index) =>
              csvData.push([
                ++index,
                tran.proposal_type,
                tran.offer_id,
                tran.offer_name,
                tran.original_price,
                tran.offer_price,
                tran.launch_date,
                tran.end_date,
                tran.City,
                tran.State,
                tran.Country,
                tran.customer_first_name,
                tran.customer_last_name,
                tran.customer_email,
                tran.customer_phone,
                tran.customer_address,
                tran.transaction_id,
                tran.transaction_date,
                tran.transaction_time,
                tran.currency,
                tran.credit_card_sale,
                tran.user_credit_used,
                tran.promo_credit_used,
                tran.gross_billing,
                tran.shipping_to_site,
                tran.shipping_to_merchant,
                tran.tax_percentage,
                tran.tax_amount,
                tran.credit_card_percentage,
                tran.credit_card_fee,
                tran.refund_amount,
                tran.adjusted_gross_sale,
                tran.site_commission,
                (tran.site_commission_percentage) ? tran.site_commission_percentage.toFixed(2) : 0,
                tran.merchant_remittance,
                (tran.merchant_commission_percentage) ? tran.merchant_commission_percentage.toFixed(2) : 0,
                tran.net_payout_to_merchant,
                tran.final_merchant_payout,
                (tran.net_to_site) ? tran.net_to_site.toFixed(2) : 0,
                tran.payment_method,
                tran.sales_representative_fullname,
                tran.payment_status,
                "",
                JSON.stringify(tran.offer_options).replace(/,/g, '||'),
                tran.merchant_id,
                tran.merchant_email,
                tran.merchant_phone,
                tran.vouchers,
                tran.gross_billing,
                "",
                "",
                tran.tracking_info_datetime,
                tran.additional_notes,
                tran.categories,
                (JSON.parse(tran.billing_address).line_2 !== null) ? JSON.parse(tran.billing_address).line_1 + ',' + JSON.parse(tran.billing_address).line_2 : JSON.parse(tran.billing_address).line_1,
                JSON.parse(tran.billing_address).city,
                JSON.parse(tran.billing_address).state,
                JSON.parse(tran.billing_address).zip,
                (JSON.parse(tran.shipping_address).line_2 !== null) ?  JSON.parse(tran.shipping_address).line_1 + ',' + JSON.parse(tran.shipping_address).line_2 : JSON.parse(tran.shipping_address).line_1,
                JSON.parse(tran.shipping_address).city,
                JSON.parse(tran.shipping_address).state,
                JSON.parse(tran.shipping_address).zip,
                tran.charity_name,
              ])
            )
        )
      )
    }

    this.setState({ csvData: csvData });
  };

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Transaction Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="offerIDs">
                    <ControlLabel>Offer IDs(separate by comma)</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.offerIDs}
                      placeholder="Offer ID"
                      onChange={this.handleChange}
                      name="offerIDs"
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="proposalType">
                    <ControlLabel>Proposal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.merchantTypeIDError }}
                      name="merchantTypeID"
                      onChange={this.handleChange}
                      value={this.state.merchantTypeID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.merchantType) &&
                        this.state.merchantType.map((type, index) => (
                          <option
                            key={type.merchantTypeID}
                            value={type.merchantTypeID}
                          >
                            {type.merchantTypeName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>

                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      name="catID"
                      onChange={this.handleChange}
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"transaction-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Proposal Type</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Original Price</th>
                  <th>Offer Price</th>
                  <th>Launch Date</th>
                  <th>End Date</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Customer First Name</th>
                  <th>Customer Last Name</th>
                  <th>Customer Email</th>
                  <th>Customer Phone</th>
                  <th>Customer Address</th>
                  <th>Transaction ID</th>
                  <th>Transaction Date</th>
                  <th>Transaction Time</th>
                  <th>Currency</th>
                  <th>Credit Card Sale</th>
                  <th>User Credits Used </th>
                  <th>Promo Code Credit Used</th>
                  <th>Gross Sale</th>
                  <th>Shipping to Site</th>
                  <th>Shipping to Merchant</th>
                  <th>Tax Percentage</th>
                  <th>Tax Amount</th>
                  <th>Credit Card %</th>
                  <th>Credit Card Fee</th>
                  <th>Refunds</th>
                  <th>Adjusted Gross</th>
                  <th>Site Commission</th>
                  <th>Site Commission %</th>
                  <th>Merchant Remittance</th>
                  <th>Merchant Remittance %</th>
                  <th>Net Payout To Merchant</th>
                  <th>Final Merchant Payout </th>
                  <th>Net To Site</th>
                  <th>Payment Method</th>
                  <th>Sales Rep Full Name</th>
                  <th>Payment Status</th>
                  <th>Pricing Option Deal Title</th>
                  <th>Offer Option</th>
                  <th>Merchant ID</th>
                  <th>Merchant Email</th>
                  <th>Phone</th>
                  <th>Vouchers</th>
                  <th>Gross Billing</th>
                  <th>Payvibe Commission</th>
                  <th>Payvibe Commission %</th>
                  <th>Tracking Info Date/Time</th>
                  <th>Additional Notes</th>
                  <th>Categories</th>
                  <th>Billing Address</th>
                  <th>Billing City</th>
                  <th>Billing State</th>
                  <th>Billing Zip</th>
                  <th>Shipping Address</th>
                  <th>Shipping City</th>
                  <th>Shipping State</th>
                  <th>Shipping Zip</th>
                  <th>Charity Name</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.transaction) ? (
                  this.state.transaction.map((data, keyIndex) => (
                    Object.keys(data).map((key, indexkey) => 
                      (key == 'title') ?
                        <tr key={data.cityID + keyIndex}>
                          <td colSpan="63">{data.title}</td>
                        </tr>
                      :
                      (key == 'transactions') &&
                        data.transactions.map((tran, index) => 
                          <tr key={Math.random()+index}>
                            <td>{++index}</td>
                            <td>{tran.proposal_type}</td>
                            <td>{tran.offer_id}</td>
                            <td>{tran.offer_name}</td>
                            <td>{tran.original_price}</td>
                            <td>{tran.offer_price}</td>
                            <td>{tran.launch_date}</td>
                            <td>{tran.end_date}</td>
                            <td>{tran.City}</td>
                            <td>{tran.State}</td>
                            <td>{tran.Country}</td>
                            <td>{tran.customer_first_name}</td>
                            <td>{tran.customer_last_name}</td>
                            <td>{tran.customer_email}</td>
                            <td>{tran.customer_phone}</td> {/*Customer Phone*/}
                            <td>{tran.customer_address}</td> {/*Customer Address*/}
                            <td>{tran.transaction_id}</td>
                            <td>{tran.transaction_date}</td>
                            <td>{tran.transaction_time}</td>
                            <td>{tran.currency}</td>
                            <td>{tran.credit_card_sale}</td>
                            <td>{tran.user_credit_used}</td> {/*User Credits Used*/}
                            <td>{tran.promo_credit_used}</td>
                            <td>{tran.gross_billing}</td>
                            <td>{tran.shipping_to_site}</td>
                            <td>{tran.shipping_to_merchant}</td>
                            <td>{tran.tax_percentage}</td>
                            <td>{tran.tax_amount}</td>
                            <td>{tran.credit_card_percentage}</td>
                            <td>{tran.credit_card_fee}</td>
                            <td>{tran.refund_amount}</td>
                            <td>{tran.adjusted_gross_sale}</td> {/*Adjusted Gross*/}
                            <td>{tran.site_commission}</td>
                            <td>{(tran.site_commission_percentage) ? tran.site_commission_percentage.toFixed(2) : 0}</td>
                            <td>{tran.merchant_remittance}</td>
                            <td>{(tran.merchant_commission_percentage) ? tran.merchant_commission_percentage.toFixed(2) : 0}</td>
                            <td>{tran.net_payout_to_merchant}</td>
                            <td>{tran.final_merchant_payout}</td>
                            <td>{(tran.net_to_site) ? tran.net_to_site.toFixed(2) : 0}</td>
                            <td>{tran.payment_method}</td>
                            <td>{tran.sales_representative_fullname}</td>
                            <td>{tran.payment_status}</td>
                            <td>{""}</td> {/*Pricing Option Deal Title*/}
                            <td>{tran.offer_options}</td> {/*Offer Option*/}
                            <td>{tran.merchant_id}</td>
                            <td>{tran.merchant_email}</td>
                            <td>{tran.merchant_phone}</td>
                            <td>{tran.vouchers}</td>
                            <td>{tran.gross_billing}</td>
                            <td>{""}</td> {/*Payvibe Commission*/}
                            <td>{""}</td> {/*Payvibe Commission %*/}
                            <td>{tran.tracking_info_datetime}</td> {/*Tracking Info Date/Time*/}
                            <td>{tran.additional_notes}</td>
                            <td>{tran.categories}</td> {/*Categories*/}
                            <td>{JSON.parse(tran.billing_address).line_1} {(JSON.parse(tran.billing_address).line_2 !== null) ? ',' + JSON.parse(tran.billing_address).line_2 : ''}</td>
                            <td>{JSON.parse(tran.billing_address).city}</td>
                            <td>{JSON.parse(tran.billing_address).state}</td>
                            <td>{JSON.parse(tran.billing_address).zip}</td>
                            <td>{JSON.parse(tran.shipping_address).line_1} {(JSON.parse(tran.shipping_address).line_2 !== null) ? ',' + JSON.parse(tran.shipping_address).line_2 : ''}</td>
                            <td>{JSON.parse(tran.shipping_address).city}</td>
                            <td>{JSON.parse(tran.shipping_address).state}</td>
                            <td>{JSON.parse(tran.shipping_address).zip}</td>
                            <td>{tran.charity_name}</td>
                          </tr>
                        )
                    )
                  ))
                ) : (
                  <tr key={Math.random()}>
                    <td colSpan="63">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    transaction: state.reportReducer.transaction
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    transactionReport
  })
)(TransactionReports);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/TransactionReports.js